import { useContext, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Center, TextInput } from '@mantine/core';
import { IconCheck } from '@tabler/icons';
import AppContext from '../../shared/AppContext';
import { AlertNotification } from '../../shared/AlertNotification';
import { TitleContainer } from '../../shared/TitleContainer';
import { useTranslation } from 'react-i18next';

const AddMission = () => {

    const [client, setClient] = useState('');
    const [manager, setManager] = useState('');
    const [label, setLabel] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const myContext = useContext(AppContext);
  const { t } = useTranslation();
    const navigate = useNavigate();

    const save = () => {
        const c = client.trim();
        const m = manager.trim();
        const l = label.trim();
        if (c.length === 0 || m.length === 0 || l.length === 0) return;
        const F = new FormData();
        F.append('client', c);
        F.append('manager', m);
        F.append('label', l);
        setIsSaving(true);
        myContext.httpClient.post(`${myContext.apiAddress}/add_mission`, F).then((res:any) => {
            if (res.data.status === true) {
                navigate(`/mission/manage/${res.data.data.id}`, { replace: true })
            } else {
                AlertNotification({message: res.data.message || "unknown error" });
            }
            setIsSaving(false);
        });
    }

    return (
        <>
        <TitleContainer>
            {t('mission.addNewMission')}
        </TitleContainer>
        <Center>
            <Card withBorder radius='lg'
                style={{minWidth: '400px'}}
            >
                <TextInput 
                    required
                    label={t('mission.client')}
                    placeholder={t('mission.clientNamePh')}
                    value={client} 
                    onChange={(event) => setClient(event.currentTarget.value)}
                    disabled={isSaving}
                />
                <TextInput 
                    required
                    label={t("mission.interimManagerLabel")}
                    placeholder={t('mission.prenomNom')}
                    value={manager} 
                    onChange={(event) => setManager(event.currentTarget.value)}
                    disabled={isSaving}
                />
                <TextInput 
                    required
                    label={t('mission.libelle')}
                    placeholder={t('mission.libelleDeLaMission')}
                    value={label} 
                    onChange={(event) => setLabel(event.currentTarget.value)}
                    disabled={isSaving}
                />
                <Center pt='sm'>
                    <Button 
                        leftIcon={<IconCheck size={14} />} 
                        loading={isSaving}
                        disabled={label.trim().length < 2}
                        onClick={() => save()}
                    >
                        {t('common.save')}
                    </Button>
                </Center>
            </Card>
        </Center>
        </>
    )
}

export { AddMission }
